import { SCAN_LIST_FAILURE, SCAN_LIST_REQUEST, SCAN_LIST_SUCCESS } from "../constants/scanListConstants";


export const scanListRequest = (oemId, search = '', page = 1, limit = 10) => ({
  type: SCAN_LIST_REQUEST,
  payload: { oemId, search, page, limit }
});

export const scanListSuccess = (data) => ({
  type: SCAN_LIST_SUCCESS,
  payload: data
});

export const scanListFailure = (error) => ({
  type: SCAN_LIST_FAILURE,
  payload: error
});